import Component from '../core/Component'

export const STATES = {
    SENT: 'is-sent'
}
export const EMITS = {}

export default class FormEvent extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            durationDatepicker: null,
            durationMoreInfo: null,
            durationDaypart: null,
            accomodationCheckbox: null,
            accomodationContainer: null
        }
    }

    prepare() {
        if (this.is(STATES.SENT)) {
            return
        }

        this.durationDatepicker = Component.getFromElement(this.ref.durationDatepicker)

        this.element.addEventListener('change', this.handleChange)

        setTimeout(() => {
            this.check()
        }, 0);
    }

    handleChange = () => {
        this.check()
    }

    check() {
        this.checkDuration()
        this.checkAccomodation()
    }

    checkDuration() {
        const inputs = this.durationDatepicker.getInputs()
        const fromInput = inputs.fromInput
        const toInput = inputs.toInput

        if (!(fromInput.value && toInput.value)) {
            this.ref.durationMoreInfo.style.display = 'none'
        } else {
            this.ref.durationMoreInfo.style.display = ''
        }

        if (fromInput.value !== toInput.value) {
            this.ref.durationDaypart.style.display = 'none'
        } else {
            this.ref.durationDaypart.style.display = ''
        }

    }

    checkAccomodation() {
        if (!this.ref.accomodationCheckbox.checked) {
            this.ref.accomodationContainer.style.display = 'none'
        } else {
            this.ref.accomodationContainer.style.display = ''
        }
    }
}